import { Typography } from "@mui/material";
import Grid from "@mui/material/GridLegacy";

export default function Slogans() {
  return (
    <Grid
      container
      spacing={3}
      flexDirection="row"
      justifyContent="center"
      sx={{
        px: 2,
        py: 4,
      }}
    >
      <Grid item xs={12}>
        <Typography
          variant="h1"
          color="white.main"
          fontWeight="bold"
          align="center"
        >
          Welcome!
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography
          variant="body2"
          color="white.main"
          fontWeight="regular"
          align="center"
        >
          Human-Centered Insights ... FLEXIBLE. AUTHENTIC. PRACTICAL.
        </Typography>
      </Grid>
    </Grid>
  );
}
